import { PdfReportsService } from './../../apiclient';
import { CustomReportsImporterComponent } from './../custom-reports-importer/custom-reports-importer.component';
import { PdfExporterService } from './../../pdf-exporter.service';
import { Component, ElementRef, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserSessionService } from '../../UserSession/user-session.service';
import {Location} from '@angular/common';
import { ReportsService } from '../../apiclient';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { InformesActionsCellComponent } from './informes.actions.cell.component';
import { ExcelExporterService } from '../../excel-exporter.service';
import { NbDialogService, NbGlobalPosition, NbToastrService } from '@nebular/theme';
import { ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS } from '@angular/platform-browser-dynamic';
import { MaintenanceLiteComponent } from '../reports/maintenance-lite/maintenance-lite.component';
import { DiseaseLiteComponent } from '../reports/disease-lite/disease-lite.component';
import EditableReport from '../reports/report-edition-interface';
import { saveAs } from 'file-saver';

var MAX_REPORTS_TO_DOWNLOAD = 100;
/**
 * Componente que renderiza el listado de informes
 */
@Component({
  selector: 'ngx-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent implements OnInit {
  tipoReporte: string;
  fechasFiltro: any;
  tipoInformeSeleccionado = null;
  literalTipoInforme = "";
  tiposInforme = [];
  tipoInformePlaceholder = "";
  usuarioSeleccionado = null;
  usuarios = [];
  loading = false;
  downloading = false;
  editingReport = false;
  reportLoadingMessage = "Cargando informes..."
  exportLoadingMessage = "Generando informe..."
  loadingMessage = this.reportLoadingMessage;
  informeSeleccionado: any;
  pdfCuadernoCampo = false;
  historicoFiltro = [];  //Esther 27/01/2022
  dropdownSettings={};  //Esther EV2022-02
  usuarioDropdownSettings = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"email",
    searchPlaceholderText:"Usuario",
    text:"Seleccione usuario"
  }
  cuadernosSettings = {
    singleSelection: false,
    selectAllText:'Seleccionar todos',
    unSelectAllText:'Desmarcar todos',
    enableSearchFilter: true,
    labelKey:"notebook",
    primaryKey:'id',
    searchPlaceholderText:"Cuaderno",
    text:"Seleccione cuaderno",
    groupBy:'campaign'
  }
  listaCuadernos = [];
  cuadernosPdf = [];

  reportEditionEnabled: Boolean;

  @ViewChild('maintenanceReport')
  maintenanceReportRef: EditableReport;

  @ViewChild('diseaseReport')
  diseaseReportRef: EditableReport;

  @ViewChild('samplingReport')
  samplingReportRef: EditableReport;

  @ViewChild('notebookReport')
  notebookRef: EditableReport;

  @ViewChild('deleteDialog')
  deleteDialogRef: TemplateRef<any>;

  @ViewChild('confirmExport')
  confirmExportRef: TemplateRef<any>;

  //@ViewChild('inputFiltroFechas')
  //filtroFechasInput: ElementRef;  //Esther 27/01/2022

  source: LocalDataSource = new LocalDataSource();
  iconos = {
    disease :'bug',
    maintenance: 'toolbox',
    sampling:'vial',
    notebook:'clipboard',
  };
  tableSettings = {
    disease : {
      noDataMessage: 'No se han encontrado plagas con esos criterios',
      actions: {
                  delete: false,
                  add: false,
                  edit:false,
                  position: 'right',
              },
      columns : {
        id: {
          title: 'ID',
          type: 'number',
          filter:false,
        },
        diseaseName: {
          title: 'Enfermedad',
          type: 'string',
          filter: false,
        },
        datetime: {
          title: 'Fecha',
          type: 'string',
          valuePrepareFunction: function(value){
              return moment(value).format('DD/MM/YYYY, HH:mm');
          },
          filter: false,
        },
        diseaseUser: {
          title: 'Usuario',
          type: 'string',
          valuePrepareFunction : function(value){
              return value.email;
          },
          filter: false,
        },
      },
    },
    maintenance : {
      noDataMessage: 'No se han encontrado mantenimientos con esos criterios',
      actions: {
                  delete: false,
                  add: false,
                  edit:false,
                  position: 'right',
              },
      columns : {
        id: {
          title: 'ID',
          type: 'number',
          filter:false,
        },
        maintenanceName: {
          title: 'Mantenimiento',
          type: 'string',
          filter: false,
        },
        datetime: {
          title: 'Fecha',
          type: 'string',
          valuePrepareFunction: function(value){
              return moment(value).format('DD/MM/YYYY, HH:mm');
          },
          filter: false,
        },
        maintenanceUser: {
          title: 'Usuario',
          type: 'string',
          valuePrepareFunction : function(value){
              return value.email;
          },
          filter: false,
        },
      },
    },
    sampling : {
      noDataMessage: 'No se han encontrado muestreos con esos criterios',
      actions: {
                  delete: false,
                  add: false,
                  edit:false,
                  position: 'right',
              },
      columns : {
        id: {
          title: 'ID',
          type: 'number',
          filter:false,
        },
        form_name: {
          title: 'Muestreo',
          type: 'string',
          filter: false,
        },
        datetime: {
          title: 'Fecha',
          type: 'string',
          valuePrepareFunction: function(value){
              return moment(value).format('DD/MM/YYYY, HH:mm');
          },
          filter: false,
        },
        reportUser: {
          title: 'Usuario',
          type: 'string',
          valuePrepareFunction : function(value){
              return value.email;
          },
          filter: false,
        },
      },
    },
    notebook : {
      noDataMessage: 'No se han encontrado registros con esos criterios',
      actions: {
                  delete: false,
                  add: false,
                  edit:false,
                  position: 'right',
              },
      columns : {
        id: {
          title: 'ID',
          type: 'number',
          filter:false,
        },
        form_name: {
          title: 'Muestreo',
          type: 'string',
          filter: false,
        },
        datetime: {
          title: 'Fecha',
          type: 'string',
          valuePrepareFunction: function(value){
              return moment(value).format('DD/MM/YYYY, HH:mm');
          },
          filter: false,
        },
        reportUser: {
          title: 'Usuario',
          type: 'string',
          valuePrepareFunction : function(value){
              return value.email;
          },
          filter: false,
        },
      },
    },
  }

  constructor(private route: ActivatedRoute,public userSessionService: UserSessionService,
    private reportsService: ReportsService,
    private location: Location,
    private excelExporterService: ExcelExporterService,
    private pdfExporterService: PdfExporterService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private pdfReportService: PdfReportsService) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: true,
      selectAllText:'Select All',
      unSelectAllText:'UnSelect All',
      enableSearchFilter: true,
      labelKey:"name",
      searchPlaceholderText:"Buscar tipo",
      text:"Seleccione tipo"
    };  //Esther EV2022-02
    this.route.paramMap.subscribe((params) => {
      this.tipoReporte = params.get('report');

          console.log(this.tipoReporte)

          this.configurarFiltro();

          this.limpiar();
      });


      this.userSessionService.getCachedUsersList().subscribe((usuarios) => {
        this.usuarios = usuarios.sort((a,b)=>a.email.toLowerCase() < b.email.toLowerCase() ? -1 : 1);
      })
    }

    /**
     * Configura el filtro superior en función del tipo de informe
     */
  configurarFiltro() {
    this.pdfCuadernoCampo = false;
    switch(this.tipoReporte){
      case 'disease':
        this.tipoInformePlaceholder = "Tipo de plaga";
        this.literalTipoInforme = "Plagas y Enfermedades"
        this.userSessionService.getCachedDiseaseList().subscribe((diseases) => {
          console.log(diseases);
          this.tiposInforme = diseases;
          this.tiposInforme.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
        })
        break;
      case 'maintenance':
        this.tipoInformePlaceholder = "Tipo de mantenimiento";
        this.literalTipoInforme = "Mantenimientos"
        this.userSessionService.getCachedMaintenanceList().subscribe((maintenances) => {
          console.log(maintenances);
          this.tiposInforme = maintenances;
          this.tiposInforme.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
        })
        break;
      case 'sampling':
          this.tipoInformePlaceholder = "Tipo de muestreo";
          this.literalTipoInforme = "Muestreos"
          this.userSessionService.getCachedSamplingList().subscribe((sampling) => {
            console.log(sampling);
            this.tiposInforme = sampling.map((muestreo) => {
              muestreo.name = muestreo.form_name;
              return muestreo;
            });
            this.tiposInforme.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
            console.log(this.tiposInforme)
          })
          break;
      case 'notebook':
            this.tipoInformePlaceholder = "Tipo de registro";
            this.literalTipoInforme = "Cuaderno de campo"


            this.pdfCuadernoCampo = this.userSessionService.user.company.pdf_reports

            if(this.pdfCuadernoCampo) {
              this.userSessionService.getCachedListaCuadernos().subscribe((lista) => {
                this.listaCuadernos = [];
                  Object.keys(lista).forEach(k => {
                    lista[k].forEach(element => {
                      this.listaCuadernos.push({notebook:k,campaign:element,id:`${k}_${element}`})
                    });
                  })
              });
            }

            this.userSessionService.getCachedNotebookList().subscribe((sampling) => {
              console.log(sampling);
              this.tiposInforme = sampling.map((muestreo) => {
                muestreo.name = muestreo.form_name;
                return muestreo;
              });
              this.tiposInforme.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
              console.log(this.tiposInforme)
            })
            break;

    }
  }

  /**
   * Carga el listado de informes
   */
  async cargarInformes() :Promise<any> {
    return new Promise((resolve,reject) => {



    this.loading=true;
    this.loadingMessage = this.exportLoadingMessage;
    this.source.reset(false);
    let inicio: Date = null;
    let fin: Date = null;
    console.log(this.tipoInformeSeleccionado);
    if(this.fechasFiltro != null){
      console.log(this.fechasFiltro)
      inicio=this.fechasFiltro.start;

      inicio.setHours(0,0,0,0);


      fin = this.fechasFiltro.end;

      if (fin == null) {
        fin = new Date(inicio)

      }
      fin.setHours(23,59,59,999)
      console.log(inicio)
      console.log(fin)
    }

    let tipo = null;
    if (this.tipoInformeSeleccionado != null && this.tipoInformeSeleccionado.length > 0) {
      tipo =this.tipoInformeSeleccionado[0].id;  //Esther EV2022-02
    }

    let usuario = null;
    if(this.usuarioSeleccionado != null && this.usuarioSeleccionado.length > 0){
      usuario = this.usuarioSeleccionado[0].id;
    }



    switch(this.tipoReporte){
      case 'disease':

        this.reportsService.diseasereportlist(-1,this.userSessionService.accessToken,inicio,fin
          ,tipo,usuario).subscribe((informes) => {
            console.log("Resultado Plagas")
            console.log(informes)
            this.reportsService.saveEntitiesToCache(informes.entities)
            this.source.load(informes.entities.map((informe => {
              (informe as any).tipoInforme = this.tipoReporte;
              return informe;
            })));
            this.loading = false;
            resolve(true);
        });
        break;

      case 'maintenance':

        this.reportsService.maintenanceportlist(-1,this.userSessionService.accessToken,inicio,fin
          ,tipo,usuario).subscribe((informes) => {
            console.log("Resultado Mantenimientos")
            console.log(informes)
            this.reportsService.saveEntitiesToCache(informes.entities)
            this.source.load(informes.entities.map((informe => {
              (informe as any).tipoInforme = this.tipoReporte;
              return informe;
            })));
            this.loading = false;
            resolve(true);
        });
        break;

      case 'sampling':
          this.reportsService.customreportlist(-1,this.userSessionService.accessToken,inicio,fin
            ,null,usuario,'sampling',tipo).subscribe((informes) => {
              console.log("Resultado muestreos")
              console.log(informes)
              this.reportsService.saveEntitiesToCache(informes.entities)
              this.source.load(informes.entities.map((informe => {
                (informe as any).tipoInforme = this.tipoReporte;
                return informe;
              })));



              this.loading = false;
              resolve(true);
          });
          break;
      case 'notebook':
            this.reportsService.customreportlist(-1,this.userSessionService.accessToken,inicio,fin
              ,null,usuario,'fieldnotebook',tipo).subscribe((informes) => {
                console.log("Resultado cuaderno de campo")
                console.log(informes)
                this.reportsService.saveEntitiesToCache(informes.entities)
                this.source.load(informes.entities.map((informe => {
                  (informe as any).tipoInforme = this.tipoReporte;
                  (informe as any).location = (informe as any).form_data.location
                  return informe;
                })));
                this.loading = false;
                resolve(true);
            });
            break;
    }

  })
  }

  /**
   * Regresa a la página anterior
   */
    back(): void{
      var objFiltro: any = new Object();
      if (this.historicoFiltro !== undefined){
        objFiltro = this.historicoFiltro.pop();
        if (objFiltro !== undefined){
          if (objFiltro.tipoInformeSeleccionado === this.tipoInformeSeleccionado && objFiltro.fechasFiltro === this.fechasFiltro && objFiltro.usuarioSeleccionado === this.usuarioSeleccionado){
            objFiltro = this.historicoFiltro.pop();
          }
          if (objFiltro !== undefined){
            this.tipoInformeSeleccionado = objFiltro.tipoInformeSeleccionado;
            this.fechasFiltro = objFiltro.fechasFiltro;
            this.usuarioSeleccionado = objFiltro.usuarioSeleccionado;
            this.cargarInformes();
          }else{
            this.limpiar();
          }
        }else{
          this.limpiar();
        }
      }
      //this.location.back()  //Esther 27/01/2022
    }

/**
     * Aplcia el filtro informado por el usuario
     */
    aplicar(): void{
        this.cargarInformes();
        //Esther 27/01/2022. Inicio
       // this.filtroFechasInput.nativeElement.value = moment(this.fechasFiltro.start).format('DD/MM/YYYY') + ' - ' + moment(this.fechasFiltro.end).format('DD/MM/YYYY');
        this.guardarFiltro();
        //Esther 27/01/2022. Fin
    }

/**
     * Guarda los valores elegidos en el filtro  //Esther 27/01/2022
     */
    guardarFiltro (): void{
      this.historicoFiltro.push({tipoInformeSeleccionado:this.tipoInformeSeleccionado, fechasFiltro:this.fechasFiltro, usuarioSeleccionado:this.usuarioSeleccionado});
      }

    /**
     * Limpia el filtro
     */
    limpiar(): void{

      this.tipoInformeSeleccionado = null;
      this.fechasFiltro = null;
      this.usuarioSeleccionado = null;
      this.source = new LocalDataSource();
      this.source.reset(true);
      this.source.refresh();
      this.informeSeleccionado = null;

    }

    /**
     * Evento disparado al seleccionar un reporte en la tabla que cargará el detalle de informe
     * @param evento
     */
    onReportSelected(evento): void {
      console.log("Cargar informe")
      console.log(evento.data);

      this.informeSeleccionado = evento.data;
        this.informeSeleccionado.showLocation = true;
      switch(evento.data.tipoInforme){
        case 'disease':
          this.informeSeleccionado.titulo = evento.data.diseaseName;
          break;
        case 'maintenance':
            this.informeSeleccionado.titulo = evento.data.maintenanceName;
            break;
        case 'sampling':
          this.informeSeleccionado.titulo = evento.data.form_name;
          break;
        case 'notebook':
          this.informeSeleccionado.titulo = evento.data.form_name;
          break;
      }

    }

    /**
     * Exporta el listado de informes cargado en formato PDF
     */
    exportarPdf(){
      this.loadingMessage = this.exportLoadingMessage;


      this.source.getFilteredAndSorted().then((elementos) => {

        if(elementos.length>MAX_REPORTS_TO_DOWNLOAD){
          this.dialogService.open(this.confirmExportRef,{context:{tipo:"pdf",elementos:elementos}})
        }else{

          this.confirmarExportar("pdf",elementos);
        }



      })



    }

    async confirmarExportar(tipo,elementos){
      this.loading = true;
        switch(tipo){
          case "pdf":
                  switch(this.tipoReporte){
                    case 'disease':
                      this.pdfExporterService.exportDiseaseReport(elementos).subscribe((exito) => {
                        this.loading = false;
                      },(error) => {
                        this.loading = false;
                        this.toastrService.danger('Ha ocurrido un error al generar el documento','Exportar informes')
                      });
                    break;
                    case 'maintenance':
                      this.pdfExporterService.exportMaintenanceReport(elementos).subscribe((exito) => {
                        this.loading = false;
                      },(error) => {
                        this.loading = false;
                        this.toastrService.danger('Ha ocurrido un error al generar el documento','Exportar informes')
                      });
                    break;
                  }
          break;

          case "excel":
            switch(this.tipoReporte){
              case 'disease':
                this.excelExporterService.exportDiseaseReport(elementos)
              break;
              case 'maintenance':
                this.excelExporterService.exportMaintenanceReport(elementos)
              break;
              case 'sampling':
                  if( null != this.tipoInformeSeleccionado){
                    await this.excelExporterService.exportCustomReport(elementos,this.tipoInformeSeleccionado[0].id);
                  }else{
                    this.toastrService.danger('Debe seleccionar un tipo de muestreo para poder generar un informe Excel','Exportar EXCEL')
                  }

                break;

              case 'notebook':
                if( null != this.tipoInformeSeleccionado){
                  await this.excelExporterService.exportCustomReport(elementos,this.tipoInformeSeleccionado[0].id);
                }else{
                  this.toastrService.danger('Debe seleccionar un tipo de cuaderno de campo para poder generar un informe Excel','Exportar EXCEL')
                }

                break;

            }

            this.loading =false
          break;

        }
    }
    dismissLoading(){
      this.loading = false;
    }
    /**
     * Exporta el lsitado de informes en formato Excel
     */
    exportarXls(){

      this.loadingMessage = this.exportLoadingMessage;
      this.source.getFilteredAndSorted().then(async (elementos) => {


        if(elementos.length == 0){
          this.toastrService.warning('No hay elementos para generar el informe Excel','Exportar EXCEL')
          return;
        }else if(elementos.length > MAX_REPORTS_TO_DOWNLOAD){
          this.dialogService.open(this.confirmExportRef,{context:{tipo:"excel",elementos:elementos}})

        }else{
            this.confirmarExportar("excel",elementos);
        }


      })
    }



    /**
     * Guarda el reporte editado
     */
    async saveReport(){
      this.editingReport = true
      try{
      switch(this.tipoReporte){
        case 'disease':
          await this.diseaseReportRef.saveReport()
        break;
        case 'maintenance':
          await this.maintenanceReportRef.saveReport()

        break;
        case 'sampling':
          await this.samplingReportRef.saveReport()

          break;

        case 'notebook':
          await this.notebookRef.saveReport()

          break;


        }
        this.cancelEdition()


        this.toastrService.success('El reporte se ha modificado satisfactoriamente','Edición de reportes')
            await this.cargarInformes()

            var allReports = await this.source.getElements();

            var tipoInforme = this.informeSeleccionado.titulo

            this.informeSeleccionado = allReports.find( e => e.id == this.informeSeleccionado.id);
            if(this.informeSeleccionado != undefined){
              this.informeSeleccionado.titulo = tipoInforme;
            }


      }catch(e){
        this.toastrService.danger(e,'Edición de reportes',{destroyByClick:true,
          position: 'bottom-left' as NbGlobalPosition,duration:5000,toastClass:'toast-full-width'})
      }finally{
        this.editingReport = false

      }

  }

  /**
   * Elimina el reporte (mediante diálogo de confirmación)
   */
    deleteReport(): void {
      switch(this.tipoReporte){
        case 'disease':
          this.dialogService.open(this.deleteDialogRef,{context:{tipoInforme:this.informeSeleccionado.diseaseName,componente:this.diseaseReportRef}})
        break;
        case 'maintenance':
          this.dialogService.open(this.deleteDialogRef,{context:{tipoInforme:this.informeSeleccionado.maintenanceName,componente:this.maintenanceReportRef}})
        break;
        case 'sampling':
          this.dialogService.open(this.deleteDialogRef,{context:{tipoInforme:this.informeSeleccionado.form_name,componente:this.samplingReportRef}})

          break;

        case 'notebook':
          this.dialogService.open(this.deleteDialogRef,{context:{tipoInforme:this.informeSeleccionado.form_name,componente:this.notebookRef}})

          break;


    }
    }

    /**
     * Confirma la eliminación del reporte
     * @param componente Componente que contiene el reporte
     */
    async confirmarEliminarReporte(componente: EditableReport){
      this.editingReport = true
      try{
      await componente.deleteReport()

          this.cargarInformes()
      }catch(e){

      }finally{
        this.informeSeleccionado = null
        this.editingReport = false
      }



    }

    /**
     * Importa reportes informados en archivo excel
     */
    importarReportes(): void {
        var dialogRef = this.dialogService.open(CustomReportsImporterComponent,{context:{reportType:this.tipoReporte,tipoInformePlaceholder:this.tipoInformePlaceholder}})

    }

    /**
     * Descarga el cuaderno PDF
     */
    async descargarCuadernoPdf() {
      this.downloading = true
      var finished = false;
      var index = 0;

      for(var c of this.cuadernosPdf){
        try{
          var data = await this.pdfReportService.getPdfReport(c.notebook,c.campaign,this.userSessionService.accessToken)
          saveAs(data, `CuadernoDeCampo_${c.notebook}_${c.campaign}.pdf`);
        }catch(error){
          finished = true;
          if(error.status == 418){
            var errorJson = JSON.parse(await error.error.text())
            this.toastrService.danger('Ha ocurrido un error al generar el cuaderno de campo.Póngase en contacto con el administrador del sistema:\n'+errorJson.message,
            'Error Cuaderno de campo',{position: 'bottom-start' as NbGlobalPosition,duration:5000,toastClass:'toast-full-width'});
          }
        }
      }



      this.downloading = false;

    }

    cancelEdition(){
      this.reportEditionEnabled=false;
      this.changeEdition(this.reportEditionEnabled);
    }

    enableEdition(){
      this.reportEditionEnabled=true;
      this.changeEdition(this.reportEditionEnabled);
    }


    private changeEdition(enabled: Boolean){
      switch(this.tipoReporte){
        case 'disease':
          this.diseaseReportRef.enableEdition(enabled);
        break;
        case 'maintenance':
          this.maintenanceReportRef.enableEdition(enabled);
           break;
        case 'sampling':
          this.samplingReportRef.enableEdition(enabled);

          break;

        case 'notebook':
          this.notebookRef.enableEdition(enabled);

          break;


    }
    }
}
